<template>
  <div id="reportContainer" class="report-container show-scroll">
    <component
      :is="currentComponent"
      :reportType="reportType"
      :cases="cases"
      :title="title"
      :district="district"
      :header="reportHeader"
      :formName="reportFormName"
      :date-range="dateRange"
      :user-role="userRole"
      @reportLoaded="reportLoaded"
      @processingDone="(...args) => processingDone(...args)"
    />
  </div>
</template>

<script>
import KualaSelangor from "@/components/report-templates/KualaSelangor";
import Maintenance from "@/components/report-templates/Maintenance";

export default {
  name: "report-container",
  props: ["reportType", "cases", "title", "district", "dateRange", "userRole"],
  components: {
    KualaSelangor,
    Maintenance,
  },
  data() {
    return {
      currentComponent: "KualaSelangor",
      reportHeader: "Kumpulan Semesta Sdn Bhd",
      reportFormName: "Borang JKR.PK(SJ).P.01-25",
    };
  },
  watch: {
    district: {
      handler() {
        if (
          this.reportType.includes("maintenance:") ||
          this.reportType == "KKE"
        ) {
          this.currentComponent = "Maintenance";
        } else {
          this.currentComponent = "KualaSelangor";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    reportLoaded(e) {
      this.$emit("reportLoaded", e);
    },
    processingDone(...args) {
      this.$emit("processingDone", ...args);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/print.scss";
</style>